






















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ButtonType } from '@getaccept/lib-ui';
import Accordion from '@getaccept/lib-shared/src/components/Accordion.vue';
import { criiptoUpdatedSubscription } from '../../../api/integrations/graphql/integration.subscriptions';
import { userLanguage } from '../../../lang';
import { BankIdStep, BankIdSigningType } from '../../types/enums/bankid-se';
import type { BankId } from '../../types/bankid';
import { SigningAction, Signing } from '../../store/signing.constants';
import type { Id } from '../../types/eid';
import { CriiptoStatus } from '../../types/enums/criipto-status';
import { getIdOptions } from '../../constants/eid-options';
import BankIdOption from '../BankIdOption.vue';
import { EidType } from '../../types/enums/eid-type';
import BankIdSe from './BankIdSe.vue';
import Criipto from './Criipto.vue';
import CriiptoButton from './CriiptoButton.vue';

@Component({
  components: {
    BankIdSe,
    Accordion,
    BankIdOption,
    Criipto,
    CriiptoButton,
  },
  data: () => ({
    ButtonType,
    BankIdStep,
  }),
})
export default class Eid extends Vue {
  @Prop() documentId: string;
  @Prop() recipientId: string;
  @Prop() authId: string;
  @Prop() jwt!: string;
  @Prop() reviewPending: boolean;

  @Signing.State('bankId') bankId: BankId;
  @Signing.State('criiptoStatus') criiptoStatus: CriiptoStatus;
  @Signing.State('selectedEid') selectedEid: Id;
  @Signing.Action(SigningAction.CancelBankIdTransaction) actionCancelBankIdTransaction: (
    ssn?: string
  ) => void;
  @Signing.Action(SigningAction.PollBankIdTransaction) pollBankIdTransaction: (payload: {
    orderRef: string;
    documentId: string;
    recipientId: string;
  }) => void;
  @Signing.Action(SigningAction.SetBankIdState) setBankIdState: (payload: {
    step: BankIdStep;
    signingType: BankIdSigningType;
  }) => void;
  @Signing.Action(SigningAction.SetCriiptoStatus) setCriiptoStatus: (status: CriiptoStatus) => void;
  @Signing.Action(SigningAction.SetSelectedEid) setSelectedEid: (eid: Id) => void;
  @Signing.Action(SigningAction.CriiptoRedirect) criiptoRedirect: () => void;

  @Watch('criiptoStatus')
  handleWatchCriiptoStatus(status: CriiptoStatus) {
    if (status === CriiptoStatus.Success) {
      this.handleSignDocument();
    }
  }

  openBankIdPicker = false;
  options: Id[] = [];

  get placeholder(): string {
    return this.selectedEid?.name || this.$t('select-an-electronic-id').toString();
  }

  get showBankIDSe(): boolean {
    return !!this.selectedEid && this.selectedEid.key === EidType.SE;
  }

  get showCriiptoIframe(): boolean {
    return [EidType.NemID, EidType.NemIDKeyFile, EidType.NemIDOrg].includes(this.selectedEid?.key);
  }

  get showCriiptoButton(): boolean {
    return [EidType.MitID, EidType.BankIDFI, EidType.NO].includes(this.selectedEid?.key);
  }

  get showEidPicker(): boolean {
    return !this.showCriiptoIframe || this.criiptoStatus !== CriiptoStatus.Loading;
  }

  get bankIdStarted(): boolean {
    return this.bankId.signingType !== BankIdSigningType.None;
  }

  selected(option: Id): boolean {
    return this.selectedEid?.key === option.key;
  }

  defaultBankIdOption(userLang: string): Id {
    switch (userLang) {
      case 'sv':
        return this.options.find(option => option.key === EidType.SE);
      case 'da':
        return this.options.find(option => option.key === EidType.NemID);
      case 'no':
      case 'nn':
      case 'nb':
        return this.options.find(option => option.key === EidType.NO);
      default:
        return null;
    }
  }

  handleRecipientsInput(selectedEid: Id) {
    this.handleCancelBankId();
    this.setSelectedEid(selectedEid);
    this.openBankIdPicker = false;
  }

  handleFirstRecipientsInput(selectedEid: Id) {
    this.setSelectedEid(selectedEid);
    this.addCriiptoSubscription();
    this.openBankIdPicker = false;
  }

  handleCriiptoRedirect() {
    this.criiptoRedirect();
  }

  handleCancelBankId() {
    this.actionCancelBankIdTransaction();
  }

  handleSignDocument() {
    if (this.reviewPending) {
      this.handleClose();
      return;
    }
    this.$emit('sign');
    this.actionCancelBankIdTransaction();
  }

  handleToggleBankIdPicker(open: boolean) {
    this.openBankIdPicker = open;
  }

  handleClose() {
    this.handleCancelBankId();
    this.$emit('close');
  }

  addCriiptoSubscription(): void {
    this.$apollo.addSmartSubscription('criiptoUpdatedSubscription', {
      query: criiptoUpdatedSubscription,
      variables: { recipientId: this.recipientId },
      result({ data }) {
        this.setCriiptoStatus(data.criiptoUpdated);
      },
    });
  }

  setDefaultEid() {
    if (!this.selectedEid) {
      this.setSelectedEid(this.defaultBankIdOption(userLanguage()));
    }
  }

  mounted() {
    this.options = getIdOptions();
    this.setDefaultEid();
    if (this.selectedEid) {
      this.addCriiptoSubscription();
    }
    if (this.criiptoStatus === CriiptoStatus.Success) {
      this.handleSignDocument();
    }
  }

  created() {
    if (this.bankId.orderRef) {
      this.pollBankIdTransaction({
        orderRef: this.bankId.orderRef,
        documentId: this.documentId,
        recipientId: this.recipientId,
      });
    }
  }
}
